<section class="content head">
  <div class="content-wrapper evidence-approval">
    <iaud-sid-stepper [status]="sid?.status" class="evidence-list--sid-step" *ngIf="Sid"></iaud-sid-stepper>

    <div class="evidence-approval--top">
      <h1>Evidence Approval</h1>
    </div>
    <div class="evidence-approval--top-buttons">
      <button mat-raised-button class="right-margin" (click)="finishLater()">Finish Later</button>
      <button mat-raised-button class="right-margin" [color]="'accent'" (click)="submitApproval()" [disabled]="!canSubmit || !capa?.canApprove">Submit</button>
    </div>

    <mat-accordion multi="true" class="evidence-approval--parents">
      <iaud-audit-detail-expansion [audit]="audit" class="evidence-approval__audit"></iaud-audit-detail-expansion>
      <iaud-finding-detail-expansion [finding]="finding" class="evidence-approval__finding"></iaud-finding-detail-expansion>
      <iaud-capa-detail-expansion [capa]="capa" class="evidence-approval__capa"></iaud-capa-detail-expansion>
    </mat-accordion>

    <iaud-activity-history-expansion [capaId]="capaId" class="evidence-approval--activity"></iaud-activity-history-expansion>

    <div class="evidence-approval__buttons">
    </div>

    <h2 class="evidence-approval__header" *ngIf="findingId">Evidence List</h2>
    <div class="evidence-list__buttons" *ngIf="hasHistory">      
      <p></p>
      <button mat-raised-button class="left-margin" [color]="'accent'" (click)="showHistory()">Evidence History</button>
      <p></p>
    </div>

    <mat-card class="evidence-approval__panel" *ngIf="!(evidenceTableData?.totalCount)">
      <div class="evidence-approval__no-evidences">
        <div class="evidence-approval__no-evidences--icon">
          +
        </div>
        <div class="evidence-approval__no-evidences--text">
          <h1>No evidences</h1>
          <p>There are no evidences</p>
          <p>Please add new evidence</p>
        </div>
      </div>
    </mat-card>
  </div>
</section>

<section class="content" *ngIf="evidenceTableData?.totalCount">
  <div class="content-wrapper">
    <iaud-table [data]="evidenceTableData" [options]="evidenceTableOptions" [forceReloadEvent]="forceReloadEvent"
      [dataRefreshCallback]="reloadEvidenceList.bind(this)" [dataDeleteCallback]="deleteData.bind(this)"
      [dataEditCallback]="editEvidence.bind(this)" [usePaginator]="false"
      [deleteTitle]="'Delete Evidence'" [deleteText]="'Are you sure you want to delete ${data.evidenceId} evidence?'">
    </iaud-table>
  </div>
</section>

<ng-template #fileCellTemplate let-rowData="rowData">
    <a href="{{evUrl}}/{{rowData.id}}/{{rowData.fileName}}" download>{{rowData.fileName}}</a>
</ng-template>

<ng-template #statusCellTemplate let-rowData="rowData">
  <mat-form-field floatLabel="never" class="evidence-approval--status-field">
    <mat-select [(ngModel)]="rowData.status" placeholder="Choose Status" (ngModelChange)="calcCanSubmit()" (disabled)="!capa?.canApprove">
      <mat-select-trigger>
          <span *ngIf="rowData.status===evidenceStatus.APPROVED"><mat-icon class="green" style="vertical-align: text-bottom">check_circle</mat-icon> Approve</span>
          <span *ngIf="rowData.status===evidenceStatus.RETURN"><mat-icon class="yellow" style="vertical-align: text-bottom">report_problem</mat-icon> Return</span>
      </mat-select-trigger>
      <mat-option value="{{evidenceStatus.APPROVED}}"><mat-icon class="green">check_circle</mat-icon> Approve</mat-option>
      <mat-option value="{{evidenceStatus.RETURN}}"><mat-icon class="yellow">report_problem</mat-icon> Return</mat-option>
    </mat-select>
  </mat-form-field>
</ng-template>
<ng-template #reasonCellTemplate let-rowData="rowData">
  <mat-form-field floatLabel="never" style="padding-left: 10px" class="evidence-approval--reason-field">
    <input matInput placeholder="{{reasonPlaceholder(rowData)}}" [value]="rowData.reason" [(ngModel)]="rowData.reason" (ngModelChange)="calcCanSubmit()"
      required="{{rowData.status === evidenceStatus.RETURN}}" (disabled)="!capa?.canApprove">
    </mat-form-field>
</ng-template>